import type { DomainSchema, PdfCardDef } from '../types';
import { fmtDate, esc, metaJoin } from '../pdf-helpers';

export const PATENTS = {
  priority: true,
  cardTitle: '{patentTitle}',
  fields: {
    patentTitle: { type: 'text', label: 'Title' },
    patentNumber: { type: 'text', label: 'Patent Number' },
    issueDate: { type: 'date', label: 'Issue Date' },
    status: { type: 'text' },
    url: { type: 'text', label: 'URL' },
    inventors: { type: 'text' },
    description: { type: 'textarea' },
  },
  layout: [
    [{ field: 'patentNumber' }, { field: 'status' }],
    [{ field: 'issueDate' }, { field: 'inventors' }],
    [{ field: 'url' }],
    [{ field: 'description' }],
  ],
  editLayout: [
    [{ field: 'patentTitle' }],
    [{ field: 'patentNumber' }, { field: 'status' }],
    [{ field: 'issueDate' }, { field: 'inventors' }],
    [{ field: 'url' }],
    [{ field: 'description' }],
  ],
} satisfies DomainSchema;

export const PatentsPdfCard: PdfCardDef = {
  styles: `
    .patent-item { padding: 0.7rem 0; border-bottom: 1px solid var(--line); }
    .patent-item:first-child { padding-top: 0; }
    .patent-item:last-child { border-bottom: none; padding-bottom: 0; }
    .patent-title { font-size: 12.5px; font-weight: 700; line-height: 1.35; }
    .patent-meta  { font-size: 11px; color: var(--muted); margin-top: 3px; display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
  `,
  render(records) {
    return records
      .map(r => {
        const meta = metaJoin([
          r['patentNumber'] ? esc(r['patentNumber']) : null,
          r['issueDate'] ? fmtDate(r['issueDate']) : null,
        ]);
        return `
          <div class="patent-item">
            <div class="patent-title">${esc(r['patentTitle'])}</div>
            <div class="patent-meta">
              ${meta}
              ${r['status'] ? `<span class="bp-status">${esc(r['status'])}</span>` : ''}
            </div>
            ${r['description'] ? `<div class="bp-note">${esc(r['description'])}</div>` : ''}
          </div>`;
      })
      .join('');
  },
};
